import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import TherapistSidebar from "../../components/TherapistSidebar";


const TherapistAdminPanel = () => {
  const location = useLocation();
    const [activeNavItem, setActiveNavItem] = useState("clients");
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  return (
        <div className="max-w-4xl w-full bg-white shadow-lg rounded-lg p-8 mx-4">
          <TherapistSidebar
        activeNavItem={activeNavItem}
        setActiveNavItem={setActiveNavItem}
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      />
      <h2 className="text-3xl font-semibold text-gray-800 text-center mb-8 ">
        Scheduling Dashboard
      </h2>

      <div className="flex justify-center gap-6">
        <Link
          to="/clients/schedule/session"
          state={location.state} 
          className="px-6 py-3 bg-green-600 text-white rounded-xl shadow hover:bg-green-700 transition"
        >
          Schedule Session
        </Link>
        <Link
          to="/clients/schedule/link-generator"
          state={location.state} 
          className="px-6 py-3 bg-orange-600 text-white rounded-xl shadow hover:bg-orange-700 transition"
        >
          Instant Session Link Generator
        </Link>
      </div>
    </div>
  );
};

export default TherapistAdminPanel;
